import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CellService } from '../cell.service';
import { Message } from 'primeng/primeng';
import { GlobalDataService } from '../../../../services/global-data.service';

export interface Pagination {
  current_page?: number;
  first_item?: number;
  first_page_url?: string;
  last_item?: number;
  last_page?: number;
  last_page_url?: string;
  next_page_url?: string;
  per_page?: number;
  prev_page_url?: string;
  total?: number;
}

@Component({
  selector: 'app-cell',
  templateUrl: './cell.component.html',
  styleUrls: ['./cell.component.css'],
  providers: [CellService]
})

export class CellComponent implements OnInit {
 
  cells: any =[];  		
  searchFilter: any = [];
  searchColumn: any = [];
  pagination: Pagination;
  loading: boolean = false;
  msgs: Message[] = [];

  constructor(
              private cellService: CellService,
              private global: GlobalDataService,
  	          private router: Router
  	         ) { }

  ngOnInit() {
      this.fillSearchColumn();
      this.pagination = {current_page: 1,per_page: 1,last_page: 1};
      this.loadCells(this.searchFilter);
  }

  loadCells(filter:any[],page: number = 1){
      this.loading = true;
  		this.cellService.getCellByFilter(filter,page).subscribe(response=> {
        this.cells=response['data']; 
        this.pagination = response['pagination'] || {current_page: 1,per_page: 1,last_page: 1};
        this.loading = false;
      });
  }

  onPaginate(event) {
    event.page = event.page + 1
    this.pagination.current_page=event.page;
    this.loadCells(this.searchFilter,this.pagination.current_page);
  }

  fillSearchColumn() {
    this.searchColumn=[];
    this.searchColumn.push({ label: "Название", value: { column: "name", type: "textbox" } });
    this.searchColumn.push({ label: "Доступность", value: { column: "active", type: "dropdown",value: [{label: "Активный", value: {value: '1', label: "Активный"}},{label: "Неактивный",value: {value: '0', label: "Неактивный"}}] }});
    this.searchColumn.push({ label: "Склад", value: { column: "store_id", type: "dropdown",value: this.global.user.stores.map(value => {
      return { label: value.name, value: { value: value.id, label: value.name } };
    }) } });
  }

  setFilter(data){
    this.searchFilter=data;
    this.loading = true;
    this.loadCells(this.searchFilter,this.pagination.current_page);
  }

  add():void {
   		this.router.navigate(['dashboard/cell-crud']);
  }  

  edit(id: any){
    	  this.router.navigate(['dashboard/cell-crud/',id]);
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/cells/cell/cell.component.ts